export default {
  namespaced: true,
  state: {
    rating: [],
    period: null,
  },
  actions: {
    // eslint-disable-next-line camelcase
    GetRating({ commit, rootGetters, dispatch }, profile_id) {
      commit('setField', { name: 'rating', value: [] });
      commit('setField', { name: 'period', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('profiles/api/v3/rating', { profile_id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'rating', value: response.data.rating });
              commit('setField', { name: 'period', value: response.data.period });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreRating({ commit }) {
      commit('setField', { name: 'rating', value: [] });
      commit('setField', { name: 'period', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
